import { IfLoginInfo } from 'models/IfLoginInfo';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ACTION_TYPES } from 'store/ActionTypes';
import { LoginUtil } from 'util/loginutil';
import { useZstdInfo } from 'zstd/useZstdInfo';

export function useLoginInfo(): IfLoginInfo {
  const loginInfo = useSelector((state: any): IfLoginInfo => state.main.loginInfo);
  return loginInfo;
}

export function useCheckLogin(): {
  checkLogin: () => boolean;
} {
  const loginInfo = useLoginInfo();
  const { setShowLoginPopup } = useZstdInfo();
  const checkLogin = useCallback(() => {
    const isLoginOk = !!loginInfo?.userId;
    if (isLoginOk) {
      return true;
    }

    setShowLoginPopup(true);
    return false;
  }, [loginInfo?.userId, setShowLoginPopup]);

  return {
    checkLogin,
  };
}

export function useLoginUtil(): LoginUtil {
  const loginInfo = useLoginInfo();
  const [loginUtil, setLoginUtil] = useState<LoginUtil>(new LoginUtil(loginInfo));
  useEffect(() => {
    setLoginUtil(new LoginUtil(loginInfo));
  }, [loginInfo]);
  return loginUtil;
}

export function useSetLoginInfo() {
  const dispatch = useDispatch();
  const callback = useCallback(
    (info: IfLoginInfo) => {
      dispatch({ type: ACTION_TYPES.MAIN.LOGIN_INFO, payload: info });
    },
    [dispatch]
  );

  return callback;
}
